import React, { FC, useState, useEffect, useMemo, useRef } from "react";
import { Row, Col, Input, Form, Select } from "antd";
import { QuestionaireType } from "../../constants/enums";
import YesNoInput from "../YesNoInput";
import ThreeButtonsInput from "../ThreeButtonsInput";
import NumberInput from "../NumberInput";
import MultipleChoiceInput from "../MultipleChoiceInput";
import BarInput from "../BarInput";
import DateInput from "../DateInput";
import CurrencyInput from "../CurrencyInput";
import LocationInput from "../LocationInput";
import FileUpload from "../FileUpload";
import EmailInput from "../EmailInput";
import TagInput from "../TagInput";
import FixedAssetInput from "../FixedAssetInput";
import ResponderInput from "../ResponderInput";
import TimeInput from "../TimeInput";
import TaskInput from "../TaskInput";
import EventInput from "../EventInput";
import ScheduleInput from "../ScheduleInput";
import NotifyTypeInput from "../NotifyTypeInput";

const { Option } = Select;
const { TextArea } = Input;

const RenderFields: FC<{
  data: any;
  name?: any;
  restFields?: any;
  projects?: any;
  addOtherLocation?: any;
  onProjectChange?: any;
  onCustomerSearch?: any;
  adminRoles?: any;
  customerDisabled?: boolean;
  dispatchDisabled?: boolean;
}> = ({
  data,
  name,
  restFields,
  projects,
  addOtherLocation,
  onProjectChange,
  adminRoles,
  onCustomerSearch,
  dispatchDisabled,
  customerDisabled
}) => {
  const itemName = [name, data?.name];
  let renderEle: any = "";
  useEffect(() => {}, []);
  switch (data.type) {
    case QuestionaireType.Text:
      renderEle = (
        <Form.Item name={itemName}>
          <TextArea
            autoSize={
              data?.isMulti
                ? { minRows: 4, maxRows: 6 }
                : { minRows: 1, maxRows: 3 }
            }
            placeholder={data?.label}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.DispatchType:
      renderEle = (
        <React.Fragment>
          <Form.Item
            name={itemName}
            rules={[
              { required: true, message: "**Required Field" },
              {
                message: "**Required Field",
                validator: async (_, value) => {
                  if (
                    (value?.value === "schedule" ||
                      value?.value === "deadline") &&
                    (!value?.date || !value?.time)
                  ) {
                    return Promise.reject("**Required Field");
                  }
                  // Promise.resolve()
                },
              },
            ]}
          >
            <ScheduleInput
              placeholder="Dispatch type"
              onChange={(value) => {
                // setDispatchType(value.value);
              }}
              disabled={dispatchDisabled}
            />
          </Form.Item>

          <Form.Item
            name="notify"
            // rules={[{ required: true, message: "**Required Field" }]}
            rules={[
              {
                message: "**Required Field",
                validator: async (_, value) => {
                  if (
                    value &&
                    (!value.notifyVia ||
                      (!value.notifyTime && !value.customTime))
                  ) {
                    return Promise.reject("**Required Field");
                  }
                  // Promise.resolve()
                },
              },
            ]}
          >
            <NotifyTypeInput onChange={(value) => {}} />
          </Form.Item>
        </React.Fragment>
      );
      break;
    case QuestionaireType.Customer:
      renderEle = (
        <Form.Item name={itemName}>
          <TextArea
            autoSize={
              data?.isMulti
                ? { minRows: 4, maxRows: 6 }
                : { minRows: 1, maxRows: 3 }
            }
            placeholder={data?.label}
            onChange={(e) => {
              onCustomerSearch({ itemName, value: e.target.value });
            }}
            disabled={customerDisabled}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.YesNo:
      renderEle = (
        <Form.Item {...restFields} name={itemName}>
          <YesNoInput placeholder={data?.label} onChange={(value) => {}} />
        </Form.Item>
      );
      break;
    case QuestionaireType.ThreeButton:
      renderEle = (
        <Form.Item name={itemName}>
          <ThreeButtonsInput placeholder={data?.label} />
        </Form.Item>
      );
      break;
    case QuestionaireType.Number:
      renderEle = (
        <div className="tiles padding-12">
          <span className="col-label">{data?.label}</span>
          <Row className="w-100 mt-3">
            <Col span={24}>
              <Form.Item name={itemName}>
                <NumberInput
                  value={data.value}
                  onChange={(num) => {
                    data.value = num;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      );
      break;
    case QuestionaireType.MultipleChoice:
      renderEle = (
        <Form.Item name={itemName}>
          <MultipleChoiceInput
            options={data?.options}
            isMulti={data.isMulti}
            placeholder={data?.label}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.Bar:
      renderEle = (
        <Form.Item name={itemName}>
          <BarInput options={data?.options} placeholder={data?.label} />
        </Form.Item>
      );
      break;
    case QuestionaireType.Date:
      renderEle = (
        <Row>
          <Col span={24}>
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <Form.Item name={itemName}>
                <DateInput placeholder={data?.label} />
              </Form.Item>
            </div>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.DateTime:
      renderEle = (
        <Row>
          <Col span={24}>
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <Form.Item name={itemName}>
                <DateInput placeholder={data?.label} />
              </Form.Item>
            </div>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Currency:
      renderEle = (
        <div className="tiles padding-12">
          <span className="col-label">{data?.label}</span>
          <Row className="w-100 mt-3">
            <Col span={24}>
              <Form.Item name={itemName}>
                <CurrencyInput
                  suffix={data.options[0]}
                  onChange={(num) => {}}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      );
      break;
    case QuestionaireType.Location:
      renderEle = (
        <Form.Item name={itemName}>
          <LocationInput
            placeholder={data?.label}
            onChange={(location) => {
              addOtherLocation({ [name ? name : data?.name]: location });
            }}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.IncidentLocation:
      renderEle = (
        <Form.Item
          name={itemName}
          rules={[{ required: true, message: "**Required Field" }]}
        >
          <LocationInput
            placeholder={data?.label}
            onChange={(location) => {
              addOtherLocation({ [name ? name : data?.name]: location });
            }}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.GPS:
      renderEle = (
        <Form.Item name={itemName}>
          <LocationInput
            placeholder={data?.label}
            onChange={(location) => {
              addOtherLocation({ [name ? name : data?.name]: location });
            }}
          />
        </Form.Item>
      );
      break;
    case QuestionaireType.File:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item name={itemName}>
              <FileUpload placeholder={data?.label} onChange={(img) => {}} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Signature:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item name={itemName}>
              <FileUpload placeholder={data?.label} onChange={(img) => {}} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Media:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item name={itemName}>
              <FileUpload placeholder={data?.label} onChange={(img) => {}} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Capture:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item name={itemName}>
              <FileUpload placeholder={data?.label} onChange={(img) => {}} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Email:
      renderEle = (
        <Form.Item name={itemName}>
          <EmailInput placeholder={data?.label} />
        </Form.Item>
      );
      break;
    case QuestionaireType.Tag:
      renderEle = (
        <Form.Item name={itemName}>
          <TagInput placeholder={data?.label} />
        </Form.Item>
      );
      break;
    case QuestionaireType.TagNot:
      renderEle = (
        <Form.Item name={itemName}>
          <TagInput placeholder={data?.label} />
        </Form.Item>
      );
      break;

    case QuestionaireType.FixedAsset:
      renderEle = (
        <Form.Item name={itemName}>
          <FixedAssetInput
            placeholder={data?.label}
            onChange={(value) => {
              addOtherLocation({
                [name ? name : data?.name]: {
                  label: value?.asset?.name,
                  value: {
                    coordinates: {
                      lat: value?.asset?.location?.coordinates?.[1],
                      long: value?.asset?.location?.coordinates?.[0],
                    },
                  },
                },
              });
            }}
          />
        </Form.Item>
      );
      break;

    case QuestionaireType.Responder:
      renderEle = (
        <Form.Item name={itemName}>
          <ResponderInput
            placeholder={data?.label}
            adminRoles={adminRoles}
            onChange={(value) => {}}
          />
        </Form.Item>
      );
      break;

    case QuestionaireType.Phone:
      renderEle = (
        <Row className="d-flex">
          <Col span={24}>
            <Form.Item name={itemName}>
              <Input className="w-full" placeholder={data?.label} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Name:
      renderEle = (
        <Row className="d-flex">
          <Col span={24}>
            <Form.Item name={itemName}>
              <Input className="w-full" placeholder={data?.label} />
            </Form.Item>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Time:
      renderEle = (
        <Row>
          <Col span={24}>
            <div className="datetime-item">
              <img src="/images/time.png" alt="" />
              <Form.Item name={itemName}>
                <TimeInput name={data?.label} onChange={(time) => {}} />
              </Form.Item>
            </div>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Event:
      renderEle = (
        <div className="tiles padding-12">
          <span className="col-label">{data?.label}</span>
          <Row className="mt-3 w-100">
            <Col span={24}>
              <Form.Item name={itemName}>
                <EventInput onChange={(time) => {}} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      );
      break;

    case QuestionaireType.TaskPicker:
      renderEle = (
        <div className="tiles padding-12">
          <span className="col-label">{data?.label}</span>
          <hr />
          <Row className="mt-3 w-100">
            <Col span={24}>
              <Form.Item name={itemName}>
                <TaskInput onChange={(tasks) => {}} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      );
      break;

    case QuestionaireType.Project:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item
              name={itemName}
              rules={[{ required: true, message: "**Required Field" }]}
            >
              <Select
                showSearch
                className="w-full"
                placeholder={data?.label}
                onChange={(value) => {
                  onProjectChange(value);
                }}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {projects?.projects?.map((project, index) => (
                  <Option value={project.id}>{project.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case QuestionaireType.Search:
      renderEle = (
        <Row>
          <Col span={24}>
            <Form.Item name={itemName}>
              {data?.isMulti ? (
                <Select
                  showSearch
                  className="w-full"
                  placeholder={data?.label}
                  mode={"multiple"}
                  onChange={(value) => {
                    onProjectChange(value);
                  }}
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {data?.options?.map((option, index) => (
                    <Option value={option}>{option}</Option>
                  ))}
                </Select>
              ) : (
                <Select
                  showSearch
                  className="w-full"
                  placeholder={data?.label}
                  onChange={(value) => {
                    onProjectChange(value);
                  }}
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {data?.options?.map((option, index) => (
                    <Option value={option}>{option}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    default:
      renderEle = "";
  }
  return renderEle;
};

export default RenderFields;
